export default __webpack_public_path__ + "static/media/spacecowboy4.5aa5fdd1.png";